import React, { useState } from 'react'
import cn from 'classnames'
import OutsideClickHandler from 'react-outside-click-handler'
import styles from './Dropdown.module.sass'
import Tooltip from '../Tooltip'

const DropdownNew = ({
  className,
  classDropdownHead,
  classDropdownLabel,
  value,
  setValue,
  options,
  label,
  tooltip,
  small,
  upBody,
  actualVal,
  setActualVal,
  revenueData,
  setRevenueData,
}) => {
  const [visible, setVisible] = useState(false)

  const handleClick = (option) => {
    setValue(option.code)
    setActualVal(option.name)
    setVisible(false)
    setRevenueData({
      ...revenueData,
      mda_id: option.id,
    })
  }

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      {label && (
        <div className={cn(styles.label, classDropdownLabel)}>
          {label}{' '}
          {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon='info'
              place='right'
            />
          )}
        </div>
      )}
      <div
        className={cn(
          styles.dropdown,
          className,
          { [styles.small]: small },
          {
            [styles.active]: visible,
          }
        )}
      >
        <div
          className={cn(styles.head, classDropdownHead)}
          onClick={() => setVisible(!visible)}
        >
          <div className={styles.selection}>{actualVal}</div>
        </div>
        <div
          className={cn(styles.body, { [styles.bodyUp]: upBody })}
          style={{
            height: '310px',
            overflow: 'scroll',
          }}
        >
          {options.map((option, index) => (
            <div
              className={cn(styles.option, {
                [styles.selectioned]: option.id === value,
              })}
              onClick={() => handleClick(option)}
              key={index}
              style={{ textAlign: 'left' }}
            >
              {option.name}
            </div>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  )
}

export default DropdownNew
